import {observable} from 'mobx';
import {I9DocExpiryDateOptionEnum, IssuingAuthority, I9DocumentGroupsEnum} from '@swipejobs/i9-document-validations-react';

export interface ISection2DocumentTypesValidation {
  documentRegex: string;
  documentType: string;
  example: string;
  expiryDateOption: I9DocExpiryDateOptionEnum;
  issuingAuthority: IssuingAuthority[];
  freeTextAllowed: boolean;
  isExpiredDocumentAllowed: boolean;
  documentNumberRequirements: string;
  i9Section2Excluded: boolean;
  title: string;
  documentGroups: I9DocumentGroupsEnum[]
}

export class Section2DocumentTypesValidationStore implements ISection2DocumentTypesValidation {
  @observable
  documentRegex: string;

  @observable
  documentType: string;

  @observable
  example: string;

  @observable
  expiryDateOption: I9DocExpiryDateOptionEnum;

  @observable
  issuingAuthority: IssuingAuthority[];

  @observable
  freeTextAllowed: boolean;

  @observable
  isExpiredDocumentAllowed: boolean;

  @observable
  documentNumberRequirements: string;

  @observable
  title: string;

  @observable
  i9Section2Excluded: boolean;

  @observable
  documentGroups: I9DocumentGroupsEnum[];

  constructor(details: {
    documentNumberRegex: string;
    documentType: string;
    documentNumberExample: string;
    expiryDateOption: I9DocExpiryDateOptionEnum;
    issuingAuthorities: IssuingAuthority[];
    freeTextAllowed: boolean;
    expiredDocumentAllowed: boolean;
    documentNumberRequirements: string;
    title: string;
    i9Section2Excluded: boolean;
    documentGroups: I9DocumentGroupsEnum[];
  }) {
    this.documentRegex = details.documentNumberRegex;
    this.documentType = details.documentType;
    this.example = details.documentNumberExample;
    this.expiryDateOption = details.expiryDateOption;
    this.issuingAuthority = details.issuingAuthorities;
    this.freeTextAllowed = details.freeTextAllowed;
    this.isExpiredDocumentAllowed = details.expiredDocumentAllowed;
    this.documentNumberRequirements = details.documentNumberRequirements;
    this.title = details.title;
    this.i9Section2Excluded = details.i9Section2Excluded;
    this.documentGroups = details.documentGroups;
  }
}



// WEBPACK FOOTER //
// ./src/stores/onboarding-review/section2-document-types-validation-store.ts